var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
export default isReactNative;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isReactNative.js
// module id = 564
// module chunks = 0